/** Humanize Soren deadline copy — never negative day counts or raw ISO. */

const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
]

export function formatShortDeadline(raw?: string | null): string | null {
  if (!raw) return null
  const m = String(raw).match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (m) {
    const month = MONTHS[parseInt(m[2], 10) - 1]
    const day = parseInt(m[3], 10)
    if (month) return `${month} ${day}`
  }
  const dt = new Date(raw)
  if (!Number.isNaN(dt.getTime())) {
    return `${MONTHS[dt.getMonth()]} ${dt.getDate()}`
  }
  return null
}

export function humanizeDaysRemaining(
  days: number,
  deadlineDate?: string | null,
): string {
  const d = Math.trunc(Number(days))
  if (!Number.isFinite(d)) return 'Deadline unknown'
  if (d < 0) {
    const overdue = Math.abs(d)
    const dateBit = formatShortDeadline(deadlineDate)
    if (dateBit) return `${overdue} day${overdue === 1 ? '' : 's'} overdue · Deadline was ${dateBit}`
    return `${overdue} day${overdue === 1 ? '' : 's'} overdue`
  }
  if (d === 0) {
    const dateBit = formatShortDeadline(deadlineDate)
    return dateBit ? `Due today · ${dateBit}` : 'Due today'
  }
  if (d === 1) return 'Due in 1 day'
  return `Due in ${d} days`
}
